import { imgUrl } from "./modules/Arrays";
import Track from "./Track";

function Body({ albums, singles }) {
    
    const albumss = albums.length !== 0 ? albums.map(album => (        
        <Track song={album} key={album.id} link={`albums/${album.title.replace(/ /g,'-')}`} img={imgUrl+"next.png"} alt={`Go to ${ album.title }`} />             
    )) : <h3>No Albums yet </h3>;

    const singless = singles.length !== 0 ? singles.map(single => (       
        <Track song={single} key={single.id} link={`singles/${single.title.replace(/ /g,'-')}`} img={imgUrl+"next.png"} alt={`Go to ${single.title }`} />
    )) : <h3>No Singles yet </h3>;

  return (
    <>
        <div className="musicals albums">
            <h4>Trending Albums</h4>
            <div className="grid-4">
                { albumss }
            </div>
        </div>
        <div className="musicals singles">
            <h4>Trending Singles</h4>
            <div className="grid-4">
            { singless }
            </div>
        </div>
    </>
  );

}

export default Body;